interface OccupationGroupOption {
    code: string;
    value: string;
    displayOrder?: string;
    inputDataExclusion?: string;
    unionCode?: string;
    unionName?: string;
}

enum InputDataExclusion {
    JobTitle = `job title`,
    MonthlyGrossSalary = `monthly gross salary`,
    Company = `company`,
}

export type { OccupationGroupOption }
export { InputDataExclusion }
